//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/NXColor.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"SeeThruStyle",1,0]],[[[],"GetWireframeBlendOptions",{R_:{wireframeBlendOptions:''}},0,0],[["wireframeBlendOptions"],"SetWireframeBlendOptions",{},1,0],[[],"GetShellOptions",{R_:{shellOptions:''}},0,0],[["shellOptions"],"SetShellOptions",{},1,0],[[],"GetOriginalColorShellOptions",{R_:{originalColorShellOptions:''}},0,0],[["originalColorShellOptions"],"SetOriginalColorShellOptions",{},1,0],[[],"GetLayersOptions",{R_:{layersOptions:''}},0,0],[["layersOptions"],"SetLayersOptions",{},1,0]],[]];
SPLM.Preferences.PartVisualizationEmphasis = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartVisualizationEmphasis";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartVisualizationEmphasis.WireframeBlendOptions = class{
    constructor(blendColor,blendPercentage){
        this.blendColor=blendColor;this.blendPercentage=blendPercentage;}
    get Blendcolor(){return this.blendColor}
    set Blendcolor(val){this.blendColor = val}
    get Blendpercentage(){return this.blendPercentage}
    set Blendpercentage(val){this.blendPercentage = val}
};

SPLM.Preferences.PartVisualizationEmphasis.ShellOptions = class{
    constructor(rgb,edges,edgesRgb,translucency){
        this.rgb=rgb;this.edges=edges;this.edgesRgb=edgesRgb;this.translucency=translucency;}
    get Rgb(){if(this.rgb === undefined) this.rgb = new SPLM.NXColor.Rgb(); return this.rgb}
    set Rgb(val){this.rgb = val}
    get Edges(){return this.edges}
    set Edges(val){this.edges = val}
    get Edgesrgb(){if(this.edgesRgb === undefined) this.edgesRgb = new SPLM.NXColor.Rgb(); return this.edgesRgb}
    set Edgesrgb(val){this.edgesRgb = val}
    get Translucency(){return this.translucency}
    set Translucency(val){this.translucency = val}
};

SPLM.Preferences.PartVisualizationEmphasis.OriginalColorShellOptions = class{
    constructor(edges,edgesRgb,translucency){
        this.edges=edges;this.edgesRgb=edgesRgb;this.translucency=translucency;}
    get Edges(){return this.edges}
    set Edges(val){this.edges = val}
    get Edgesrgb(){if(this.edgesRgb === undefined) this.edgesRgb = new SPLM.NXColor.Rgb(); return this.edgesRgb}
    set Edgesrgb(val){this.edgesRgb = val}
    get Translucency(){return this.translucency}
    set Translucency(val){this.translucency = val}
};

SPLM.Preferences.PartVisualizationEmphasis.LayersOptions = class{
    constructor(rgb,edges,edgesRgb,translucency){
        this.rgb=rgb;this.edges=edges;this.edgesRgb=edgesRgb;this.translucency=translucency;}
    get Rgb(){if(this.rgb === undefined) this.rgb = new SPLM.NXColor.Rgb(); return this.rgb}
    set Rgb(val){this.rgb = val}
    get Edges(){return this.edges}
    set Edges(val){this.edges = val}
    get Edgesrgb(){if(this.edgesRgb === undefined) this.edgesRgb = new SPLM.NXColor.Rgb(); return this.edgesRgb}
    set Edgesrgb(val){this.edgesRgb = val}
    get Translucency(){return this.translucency}
    set Translucency(val){this.translucency = val}
};

SPLM.Preferences.PartVisualizationEmphasis.SeeThruStyleType = Object.freeze({
    "Shell" : "Shell", "OriginalColorShell" : "OriginalColorShell", "Layers" : "Layers"});

SPLM.Preferences.PartVisualizationEmphasis.EdgesType = Object.freeze({
    "Off" : "Off", "Normal" : "Normal"});

export default SPLM;